<template>
  <div>
    <common-hero :title="textElements.title" :subTitle="textElements.subTitle" />
    <div class="container" v-if="!textElements.textBox">
      <div class="row">
        <div class="col-lg-12">
          <div class="blog-area">
            <div class="blog-text" v-html="textElements.text"></div>
          </div>
        </div>
      </div>
    </div>
    <article-item :textElements="textElements" type="noTitle" v-else />
  </div>
</template>

<script>
import CommonHero from '@/components/CommonHero';
import ArticleItem from './ArticleItem.vue';
export default {
  components: {
    CommonHero,
    ArticleItem
  },
  props: {
    textElements: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="scss">
.blog-text h3 {
  margin-bottom: 10px;
}
.blog-text p {
  font-family: 'Montserrat', sans-serif;
  padding-bottom: 10px;
}

.blog-text li {
  font-family: 'Montserrat', sans-serif;
  padding-bottom: 5px;
}
</style>
